module.exports = __webpack_public_path__ + "img/wenti_banner.2fd6c65f.jpg";